module.exports = __webpack_public_path__ + "static/media/fantasyomatic-personas-persona-frank@2x.eb83a26b.png";